import { getAnalytics, isSupported, logEvent, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { firebaseApp } from "../firebase/firebase";
import { Settings } from "../storage/store";

// "Share Usage Statistics": Firebase Analytics in the same Firebase project as
// the app. As in the app it's off until the user turns it on, and nothing is
// loaded until then.

let analytics = null;
let lastPath = null;

const start = async () => {
  if (analytics) return analytics;
  const app = firebaseApp();
  if (!app || !(await isSupported().catch(() => false))) return null;
  analytics = getAnalytics(app);
  return analytics;
};

// Resolves to false when this browser can't send analytics.
export const setAnalytics = async (enabled) => {
  Settings.setAnalytics(enabled);
  if (!enabled) {
    if (analytics) setAnalyticsCollectionEnabled(analytics, false);
    return true;
  }
  const started = await start();
  if (!started) return false;
  setAnalyticsCollectionEnabled(started, true);
  lastPath = window.location.pathname;
  return true;
};

// Called on start-up and after every change of page. Firebase counts the page
// it starts on by itself; later pages are logged here.
export const trackPage = async (path) => {
  if (!Settings.getAnalytics() || path === lastPath) return;
  const first = !analytics;
  const started = await start();
  if (!started) return;
  if (!first) logEvent(started, "page_view", { page_path: path, page_location: window.location.origin + path });
  lastPath = path;
};
